import { Icon } from "./Icon";

interface GraphControlsProps {
  autoRotate: boolean;
  hasSelectedNode: boolean;
  listOpen: boolean;
  reducedMotion: boolean;
  resultCount: number;
  totalCount: number;
  onAutoRotateChange: (enabled: boolean) => void;
  onListToggle: () => void;
  onReset: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
}

export function GraphControls({
  autoRotate,
  hasSelectedNode,
  listOpen,
  reducedMotion,
  resultCount,
  totalCount,
  onAutoRotateChange,
  onListToggle,
  onReset,
  onZoomIn,
  onZoomOut,
}: GraphControlsProps) {
  return (
    <div className="graph-controls-wrap">
      <p className="graph-instruction" hidden={hasSelectedNode} id="graph-instructions">
        노드 선택 → 연결 보기
      </p>
      <div className="graph-controls" role="toolbar" aria-label="그래프 보기 도구">
        <button
          aria-label="자동 회전"
          aria-pressed={autoRotate}
          className={autoRotate ? "is-active" : ""}
          disabled={reducedMotion}
          onClick={() => onAutoRotateChange(!autoRotate)}
          title={reducedMotion ? "동작 줄이기 설정이 켜져 있습니다" : "자동 회전"}
          type="button"
        >
          <Icon name="rotate" size={17} />
          <span>회전</span>
        </button>
        <span className="control-divider" aria-hidden="true" />
        <button aria-label="축소" onClick={onZoomOut} title="축소" type="button">
          <Icon name="minus" size={17} />
        </button>
        <button aria-label="확대" onClick={onZoomIn} title="확대" type="button">
          <Icon name="plus" size={17} />
        </button>
        <button aria-label="그래프 보기 초기화" onClick={onReset} type="button">
          <Icon name="center" size={17} />
          <span>초기화</span>
        </button>
        <span className="control-divider" aria-hidden="true" />
        <button
          aria-label={listOpen ? "키보드 노드 목록 닫기" : "키보드 노드 목록 열기"}
          aria-expanded={listOpen}
          aria-pressed={listOpen}
          className={listOpen ? "is-active" : ""}
          onClick={onListToggle}
          type="button"
        >
          <Icon name="list" size={17} />
          <span>목록</span>
          <span className="visible-count" aria-label={`${resultCount}개 노드 표시`}>
            {resultCount}/{totalCount}
          </span>
        </button>
      </div>
    </div>
  );
}
